import Vue from 'vue';
import apiUtil from './api';

declare module 'vue/types/vue' {
  interface VueConstructor {
    http: any;
  }
}

export default class AppApi {
  /**
   * 查询微信签名 http://showdoc.nevint.com/index.php?s=/lifestyle&page_id=881
   * @param {string} baseUrl  接口请求的url
   * @param {string} signUrl  需要获取签名的URL
   */
  public wxConfigSig(baseUrl: string, signUrl: string) {
    const url = baseUrl + '/api/1/lifestyle/wx_config_sig';
    const params = {
      url: signUrl,
    };
    return apiUtil.post(url, params, {
      emulateJSON: true,
    });
  }
}
